import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=284e6d8e&scoped=true&"
import script from "./CallHistory.vue?vue&type=script&lang=js&"
export * from "./CallHistory.vue?vue&type=script&lang=js&"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=284e6d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e6d8e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VDivider,VHover,VIcon,VList,VListItem,VListItemContent})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284e6d8e')) {
      api.createRecord('284e6d8e', component.options)
    } else {
      api.reload('284e6d8e', component.options)
    }
    module.hot.accept("./CallHistory.vue?vue&type=template&id=284e6d8e&scoped=true&", function () {
      api.rerender('284e6d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/phone/components/CallHistory.vue"
export default component.exports